"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t={example1:{translation:"Example 1"}};exports.default=t;
//# sourceMappingURL=translations-DikbxpvP.js.map
